import React, { Component } from 'react';
import classNames from 'classnames';
import { languageChangeEvent, LocaleString } from '@nackle/intl-tools';

import './footer.less';

export default class Footer extends Component {
    state = { isLoaded: false };

    componentDidMount() {
        languageChangeEvent.on( ( { localeCode, bundle } ) => {
            this.setState( {
                isLoaded: true,
                locale: localeCode
            } );
        } );
    }

    render() {
        const { isLoaded } = this.state;
        const { loading } = this.props;
        const classes = classNames( 'deck-footer', 'deck-common', this.props.classNames );

        return (
            <div className={ classes }>
                <div className={ isLoaded || loading ? '' : 'deck-footer-loading' }>
                    <p className="deck-footer-copyright">
                        <LocaleString
                            code="deck.content.copyright"
                            replaceOptions={ {
                                year: new Date().getFullYear()
                            } }/>
                    </p>
                </div>
            </div>
        );
    }
}